import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { EmailResponse } from '../../shared/models/email-response.model';
import { IdAndMessageResponse } from '../../shared/models/id-message-response.model';

import { UserCreateDto } from './dto/user-create';
import { UserEditDto } from './dto/user-edit';
import { UserRegistrationDto } from './dto/user-registration';

@Injectable({
	providedIn: 'root',
})
export class UsersService {
	loggedUser?: UserRegistrationDto | null = null;

	private readonly endpoint: string = `${environment.apiUrl}/user`;

	constructor(private readonly http: HttpClient) {}

	createUser({
		dto,
		organizationId,
	}: {
		dto: UserCreateDto;
		organizationId: string;
	}): Observable<IdAndMessageResponse> {
		return this.http.post<IdAndMessageResponse>(
			`${this.endpoint}/v1/register/${organizationId}`,
			dto,
		);
	}

	editUser({
		dto,
		organizationId,
		userId,
	}: {
		dto: UserEditDto;
		organizationId: string;
		userId: string;
	}): Observable<IdAndMessageResponse> {
		return this.http.patch<IdAndMessageResponse>(
			`${this.endpoint}/${userId}/organizations/${organizationId}`,
			dto,
		);
	}

	getUser(): UserRegistrationDto | null {
		return this.loggedUser || null;
	}

	resetPassword(cpf: string): Observable<EmailResponse> {
		return this.http.post<EmailResponse>(`${this.endpoint}/v1/reset-password`, {
			cpf,
		});
	}

	searchUserByOrganization(userId: string): Observable<UserRegistrationDto> {
		return this.http.get<UserRegistrationDto>(
			`${this.endpoint}/v1/by-org/${userId}`,
		);
	}

	setUser(user: UserRegistrationDto): void {
		this.loggedUser = user;
	}

	updateUserReceiveNotifications(): Observable<any> {
		return this.http.patch<any>(`${this.endpoint}/me/notification-logs`, {});
	}
}
